export enum HttpStatus {
  VALIDATION_ERROR = 422,
  LOCKED = 423,
  RATE_LIMIT = 429
}

export const ERROR_CODES = {
  SPECIAL_FORMAT_ERRORS: [1105, 1201]
} as const;

export const DEFAULT_ERROR_MESSAGE = 'tabulator.ajax.error';

export const ApiStatusErrorMessage = {
  [HttpStatus.LOCKED]: 'apiStatusCodes.423',
  [HttpStatus.RATE_LIMIT]: 'apiStatusCodes.429'
} as const;
